export default __webpack_public_path__ + "static/tpn-41a3aacdb7a09f127e5182f0dd548dd9.png";